import "./components/video";
import "./components/bottom-nav";
import "./components/scoll.min";
import "./components/scrollreveal.min";
